import { createClient, postRequestFactory, SaveOperation } from '@infuse/api/common';
import { ComponentDto, VariableDto } from '../component-model/dto';
import { AttributeType } from '../component-model/model';
import { commandPermissions } from './command-permissions';
import { ConfigureResponse } from './configure';

export interface GetConfigurationValues {
  attributeType?: AttributeType;
  component: ComponentDto;
  variable: VariableDto;
}

export interface GetConfigurationCommand {
  configurationValues: GetConfigurationValues[];
}

const client = createClient('/rest/operator-api/charging-stations');

export enum GetConfigurationResponseStatus {
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  UNKOWN_COMPONENT = 'UNKNOWN_COMPONENT',
  UNKNOWN_VARIABLE = 'UNKNOWN_VARIABLE',
  NOT_SUPPORTED_ATTRIBUTE_TYPE = 'NOT_SUPPORTED_ATTRIBUTE_TYPE'
}

export const getConfiguration: SaveOperation<GetConfigurationCommand, ConfigureResponse, string> = postRequestFactory<
  GetConfigurationCommand,
  ConfigureResponse,
  string
>(client, {
  pattern: '/{chargingStationId}/get-configuration',
  permissionId: commandPermissions.GET_CONFIGURATION
});
